import React, { useState } from 'react';
import { Button, Menu, MenuItem} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    optionCount: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "20px",
      width: "20px",
      borderRadius: "50%",
      backgroundColor: '#C4CAF1', 
      color: '#3747B0',
      marginLeft: theme.spacing(1)
    },
    label: {
      fontSize: "1rem",
      maxWidth: "200px", 
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      color: "#64768C"
    }
  }));

const FilterButton = ({ label, options, onFilterChange, disabled = false }) => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)
  const [selectedOption, setSelectedOption] = useState(options[0])

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleOptionSelect = (option) => {
    setSelectedOption(option)
    onFilterChange(option)
    handleClose()
  }

  return (
    <div>
      <Button
        variant="outlined"
        sx={{ bgcolor: '#fff', borderColor: '#CBD2DB' }}
        disabled={disabled}
        onClick={handleClick}
      >
        <span className={classes.label}>{label}</span>
        <KeyboardArrowDownIcon sx={{ color: '#64768C' }} />
        <div className={classes.optionCount}>{options.length}</div>
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {options.map((option) => (
          <MenuItem key={option} onClick={() => handleOptionSelect(option)}>
            {option}
          </MenuItem>
        ))}
      </Menu>
    </div>
  )
}
  
  export default FilterButton;
